import DialogContent from "@mui/material/DialogContent";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { AppDialog } from "../../components/AppDialog";
import { AppDialogHeader } from "../../components/AppDialogHeader";
import { confirmDialog, promptDialog } from "../../../dialogs";
import { renameAlbumApi, deleteAlbumAndRefreshGallery } from "../../../albumsApi";
import type { Album } from "../../../types";

export function AlbumOptionsDialog({
  album,
  onClose,
  onManageTags,
}: {
  album: Album | null;
  onClose: () => void;
  onManageTags: (albumId: string) => void;
}) {
  if (!album) return null;

  function handleManageTags() {
    onClose();
    onManageTags(album!.id);
  }

  async function handleRename() {
    onClose();
    const newName = await promptDialog({
      title: "Rename Album",
      initialValue: album!.name,
      placeholder: "Album name",
      confirmLabel: "Rename",
    });
    if (newName && newName !== album!.name) {
      renameAlbumApi(album!.id, newName);
    }
  }

  async function handleDelete() {
    onClose();
    const ok = await confirmDialog({
      title: "Delete Album",
      message: `Delete album "${album!.name}"? Media will remain in "All Media".`,
      confirmLabel: "Delete",
    });
    if (ok) deleteAlbumAndRefreshGallery(album!.id);
  }

  return (
    <AppDialog open onClose={onClose} maxWidth="xs" fullWidth>
      <AppDialogHeader icon="bi-images" title="Album Options" onBack={onClose} />
      <DialogContent sx={{ p: 4, pt: 2 }}>
        <Box sx={{ display: "grid", gap: 1 }}>
          <Button variant="outlined" color="primary" sx={{ justifyContent: "flex-start" }} onClick={handleRename}>
            <i className="bi bi-pencil me-2" aria-hidden="true" style={{ marginRight: 8 }} />
            Rename Album
          </Button>
          <Button variant="outlined" color="primary" sx={{ justifyContent: "flex-start" }} onClick={handleManageTags}>
            <i className="bi bi-tags me-2" aria-hidden="true" style={{ marginRight: 8 }} />
            Manage Tags
          </Button>
          <Button variant="outlined" color="error" sx={{ justifyContent: "flex-start" }} onClick={handleDelete}>
            <i className="bi bi-trash3 me-2" aria-hidden="true" style={{ marginRight: 8 }} />
            Delete Album
          </Button>
          <Button variant="outlined" color="primary" onClick={onClose}>
            Cancel
          </Button>
        </Box>
      </DialogContent>
    </AppDialog>
  );
}
